import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../TabPanel';
import Button from '../Button'

function SpecialtyEditModal(props) {
  const {
    specialty,
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
    }
  } = props;

  const [name, setName] = useState(specialty.name || '');
  const [shortName, setShortName] = useState(specialty.shortName || '');
  const [validationErrors, setValidationErrors] = useState({});

  const onChange = setter => event => {
    setter(event.target.value)
    setValidationErrors({ ...validationErrors, [event.target.name]: false })
  };

  const onSave = () => {
    save({ id: specialty.id, name, shortName });
  }

  const validate = () => {
    let valid = true
    const nextState = {}
    if (!name) {
      nextState.name = 'Required'
      valid = false
    }
    if (!shortName) {
      nextState.shortName = 'Required'
      valid = false
    }
    setValidationErrors(nextState)
    return valid
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{specialty.name || 'New Specialty'}</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>


      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Profile" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              name="name"
              label="Name"
              value={name}
              onChange={onChange(setName)}
              error={validationErrors.name}
              helperText={validationErrors.name}
              className={input}
            />

            <TextField
              fullWidth
              disabled={!!specialty.id}
              variant="outlined"
              name="shortName"
              label="Short Name"
              value={shortName}
              onChange={onChange(setShortName)}
              error={validationErrors.shortName}
              helperText={validationErrors.shortName}
              className={input}
            />
          </DialogContent>

          <Grid container justifyContent="flex-end" classes={{ container: actions }}>
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={onSave}
                onClickValidation={validate}
              >
                Save Specialty
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

SpecialtyEditModal.propTypes = {
  insurance: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(SpecialtyEditModal);
